export default class Cursor {
	constructor() {
		// Position
		this.clientX = -67;
		this.clientY = -67;

		// DOM Elements
		this.cursorWrapper = document.querySelector('[data-cursor-wrapper]');

		// Cursors
		this.cursors = Array.from(this.cursorWrapper.querySelectorAll('[data-cursor]'));

		// Cursor selectors
		this.currentElement = null;
		this.selectors = {
			viewProject: '.c-card-project__image, .m-project-gallery__item img',
			viewService: '.c-card-service__image',
			viewArticle: '.c-card-news__card__img',
			swipe: '.swiper-slide',
		};

		// Event listeners

		document.addEventListener('mousemove', (e) => {
			this.clientX = e.clientX;
			this.clientY = e.clientY;
		});

		document.addEventListener('mouseover', (e) => {
			const target = e.target;

			for (const [type, selector] of Object.entries(this.selectors)) {
				if (typeof target.closest == 'function' && target.closest(selector)) {
					this.handleMouseOver(target, type, selector);
				}
			}
		});

		document.addEventListener('mouseout', (e) => {
			const relatedTarget = e.relatedTarget;
			const target = e.target;

			for (const [type, selector] of Object.entries(this.selectors)) {
				if (typeof target.closest == 'function' && target.closest(selector)) {
					this.handleMouseOut(relatedTarget, type, selector);
				}
			}
		});

		requestAnimationFrame((timestamp) => this.render(timestamp));
	}

	handleMouseOver(target, type, selectors) {
		if (this.currentElement == target.closest(selectors)) {
			return;
		}

		this.currentElement = target.closest(selectors);
		this.showCursor(type);
	}

	handleMouseOut(relatedTarget, type, selectors) {
		if (relatedTarget && relatedTarget.closest(selectors) == this.currentElement) {
			return;
		}

		this.hideCursor(type);
		this.currentElement = null;
	}

	showCursor(type) {
		this.cursors.forEach((cursor) => {
			if (cursor.dataset.cursor == type) {
				cursor.classList.add('is-active');
			} else {
				cursor.classList.remove('is-active');
			}
		});
	}

	hideCursor(type) {
		this.cursors.forEach((cursor) => {
            if (cursor.dataset.cursor == type) {
                cursor.classList.remove('is-active');
			}
		});
	}

	render(timestamp) {
		this.cursorWrapper.style.transform = `translate(${this.clientX}px, ${this.clientY}px)`;
		requestAnimationFrame((timestamp) => this.render(timestamp));
	}
}
